import listingSocialShare from 'listings/scripts/listing_share_buttons'

$(function () {
  listingSocialShare.init()
})
